import Vue from 'vue'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import App from '@/App.vue'
import '@/plugins'

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
